export default "__VITE_ASSET__VWgdIfgm__"